module.exports = __webpack_public_path__ + "static/media/visa.89f8cfd3.png";